<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Tipo de Examen</h4>
    <hr />

    <DataTable
      :data="tipoexamens"
      :columns="columnas"
      idField="idTipoExamen"
      mensajeVacio="No hay tipos de examen registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idTipoExamen)"
      @view="row => abrirEditar(row.idTipoExamen)"
      @delete="row => deleteTipoExamen(row.idTipoExamen)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoExamen.idTipoExamen"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoExamen.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Tipo -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Tipo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoExamen.tipo"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarTipoExamen"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarTipoExamen"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "TipoExamenList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      tipoexamens:    [],
      datoTipoExamen: {},
      nombreBusqueda: "",
      titulo:         "",
      btnCrear:       false,
      btnEditar:      false,
      modalWindow:    true,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Nombre", field: "nombre" },
        { label: "Tipo",   field: "tipo"   },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwtipoexamens")
        .then(r => { this.tipoexamens = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar tipos de examen:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwtipoexamens/nombre/" + nombre)
        .then(r => { this.tipoexamens = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar tipo de examen:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoTipoExamen,
        ["nombre"],
        ["Nombre"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarTipoExamen() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/tipoexamens", this.datoTipoExamen);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tipo de examen creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarTipoExamen() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/tipoexamens", this.datoTipoExamen);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tipo de examen actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteTipoExamen(idTipoExamen) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar tipo de examen?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/tipoexamens/" + idTipoExamen);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow    = true;
      this.datoTipoExamen = {};
      this.titulo         = "Crear Tipo de Examen";
      this.btnCrear       = true;
      this.btnEditar      = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idTipoExamen) {
      this.modalWindow = true;
      this.titulo      = "Editar Tipo de Examen";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp          = await api.get("/vwtipoexamens/" + idTipoExamen);
        this.datoTipoExamen = resp.data;
      } catch (e) {
        console.error("Error al cargar tipo de examen:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idTipoExamen) {
      if (idTipoExamen != null) this.$router.push("/tipoexamen_examen/" + idTipoExamen);
    },
  },
};
</script>